module.exports = __webpack_public_path__ + "static/media/sims.e54aa6c3.png";